module.exports = __webpack_public_path__ + "img/mundi-play-card-chip.4c09b72e.png";